<template>
	<AppLayout :title="trans('general.users.roles.title')">
		<Modal id="create-role-modal">
			<template #title>{{ trans('general.users.roles.create.title') }}</template>
			<LabeledObject>
				<template #label>{{ trans('general.users.roles.attributes.name') }}</template>
				<input v-model="form.title" type="text" maxlength="255">
			</LabeledObject>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click.stop="create">
					<i class="fa-solid fa-check mr-2"/>
					{{ trans('general.confirm') }}
				</PrimaryButton>
			</template>
		</Modal>
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="showModal('create-role-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Empty v-if="roles.length === 0"/>
		<CardGrid v-else>
			<Card v-for="role in roles" :key="`role-${role.id}`" :title="role.title" :subtitle="transChoice('admin.roles.abilities', role.abilities_count)">
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.roles.edit', role.id)">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Modal from '@/Components/UI/Modals/Modal.vue'
import {type Role} from '@/Types/Association/Role'
import {trans, transChoice} from 'laravel-vue-i18n'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type InertiaForm, Link, useForm} from '@inertiajs/vue3'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	roles:Array<Role>,
}>()

const working:Ref<boolean> = ref(false)
const roles:Ref<Array<Role>> = ref(props.roles)
const form:InertiaForm<Role> = useForm<Role>({
	title: '',
} as Role)

function create():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		form.post(route('association.roles.store'), {
			onSuccess: () => {
				showSuccess(trans('general.inserted'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
			},
		})
	}
}
</script>